var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-note",attrs:{"id":"addBt"},on:{"click":_vm.showAddArea}},[_c('img',{staticClass:"addImg",attrs:{"src":require("@/assets/plus.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }